// extracted by mini-css-extract-plugin
export default {"info-icon":"LocationInfrastructure_info-icon__p11v0"};